// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"331":"8605830a","423":"8605830a","936":"8605830a"}[chunkId] + ".chunk.css";
};